<template>
  <SudoStatus
    :globalAdmin="globalAdmin"
    :globalAdminPasswordless="globalAdminPasswordless"
    :item="getItem"
    :parentType="parentType"
    :showNewWorkflow="showNewWorkflow"
    storeModule="SystemCollection"
    :sudoersContextIsWindows="isWindows"
    :system="{ id: item.id, name: item.displayName }"
    :user="user"
    :viewport="viewport"
  />
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import Constants, { ItemTypeConsts } from 'client/util/Constants';
import SudoStatus from 'client/components/ItemTable/BodyComponents/SudoStatus.vue';

export default {
  name: 'SystemSudoStatus',

  components: {
    SudoStatus,
  },

  props: {
    item: {
      required: true,
      type: Object,
    },
    showNewWorkflow: {
      type: Boolean,
      default: false,
    },
    viewport: {
      default: null,
      required: false,
      type: Object,
    },
  },

  data() {
    return {
      parentType: ItemTypeConsts.systemUser,
    };
  },

  computed: {
    ...mapGetters('SystemUserModel', {
      parent: 'item',
      parentDisplayName: 'displayName',
      parentId: 'id',
    }),

    ...mapState('SystemCollection', {
      boundItems: state => state.entities.boundItems.byId,
    }),

    /*
    *  NOTE:
       This logic is temporary until we can figure out
       what is happening with path property when show bound
       is checked / unchecked.
       The idea is to do a deep review how CollectionModule
       is calling the corresponding apis to fetch data and
       retreive paths object for each item.
    */

    getItem() {
      const item = this.boundItems[this.item.id] || null;
      if (item) return { ...this.item, paths: item.paths };
      return this.item;
    },

    globalAdmin() {
      return !!(this.user && this.user.sudo);
    },

    globalAdminPasswordless() {
      return !!(this.user && this.user.passwordless_sudo);
    },

    isWindows() {
      return (this.item && this.item.os === Constants.windows);
    },

    user() {
      let parentInfo = null;
      if (this.parent) {
        parentInfo = { ...this.parent, id: this.parentId, name: this.parentDisplayName };
      }
      return parentInfo;
    },
  },
};
</script>
